import React, { FC } from "react";

import JobEdit from "../../components/Job/JobEdit";

const JobEditPage: FC = () => <JobEdit />;

export default JobEditPage;
